import { SourceCodeRepository } from '@/domain/repositories/sourceCode/sourceCodeRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { judgeReviewDecoder } from '@/infrastructure/decoders/modelAnswer/judgeReviewDecoder'

export class SourceCodeRepositoryImpl implements SourceCodeRepository {
  constructor(private clients: ApiClients) {}

  async getSourceCodeByJudgeId(judgeId: number): Promise<string> {
    const path = `reviews/${judgeId}`
    const data = await this.clients.aojClient.fetchAndDecode(judgeReviewDecoder, path)
    return data.sourceCode
  }
}
